<template lang="pug">
div
  section.u-mt-lg
    AppTitle.u-mb-0(:title="$t('mantra')")

  .u-mb-mi

</template>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Egyptos",
    "pageDesc":"Documenting Egypt heritage by drawing the important landmarks using a unique art style created especially for Egyptos.",
    "mantra":"Documenting Egypt |from upper side |to lower side."
  },
  "ar": {
    "pageTitle":"ايجيبتوس",
    "pageDesc":"توثيق مدن مصر ومعالمها المبهرة والفريدة من خلال رسمها رقميًا باستخدام أسلوب فني فريد تم إنشائه خصيصًا لمشروع ايجيبتوس.",
    "mantra":"نوثق كل جزء في |مصر من الشمال| إلى الجنوب."
  }
}
</i18n>
